import axios from "./index";

class AccountApi {
  static Index = (params ) => {
    return axios.get(`accounts`,{
      params    
    });
  };

  static Store = (data) => {
    return axios.post(`accounts`, data);
  };

  static GenerateExcel = (data) => {
    return axios.post(`accounts/excel`, data, {
      responseType: "blob",
      headers: {
        Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      },
    });
  };

  static Get = (account_id) => {
    return axios.get(`accounts/${account_id}`);
  };

  static Update = (account_id,data) => {
    return axios.put(`accounts/${account_id}`,data);
  };
  
  static UpdateCode = (account_code_id,data) => {
    return axios.put(`account-codes/${account_code_id}`,data);
  };

  static SaveCodes = (data) => {
    return axios.post(`account-codes/import`,data);
  };

  static UpdateStatus = (account_status_id,data) => {
    return axios.put(`account-statuses/${account_status_id}`,data);
  };

  static SalesHistory = (account_id) => {
    return axios.get(`accounts/${account_id}/activity`);
  };

}

let base = "";

export default AccountApi;
